import { render, staticRenderFns } from "./BackgroundView.vue?vue&type=template&id=6b0ed090&scoped=true"
import script from "./BackgroundView.vue?vue&type=script&lang=js"
export * from "./BackgroundView.vue?vue&type=script&lang=js"
import style0 from "./BackgroundView.vue?vue&type=style&index=0&id=6b0ed090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ed090",
  null
  
)

export default component.exports